import {
    ADD_ERROR, CLEAR_ERROR
} from './constants';

const initialState = {
    code: null,
    errorType: null,
    message: null
};

function errorReducer(state = initialState, action) {
    switch(action.type) {
        case ADD_ERROR:
            return Object.assign({}, state, {
                code: action.code,
                errorType: action.errorType,
                message: action.message
            });
        case CLEAR_ERROR:
            return initialState;
        default:
            return state;
    }
}

export default errorReducer;



// WEBPACK FOOTER //
// ./src/containers/Errors/store/reducers.js